import type FlightInfoStore from '@tajawal/web-flights-sdk/lib/stores/flight-info.store';
import { useMapStoreStateToClientState } from './useMapStoreStateToClientState';

// custom hook to read the props
const useStateOfFlightDetails = (flightInfoStore: FlightInfoStore) => {
  return useMapStoreStateToClientState(flightInfoStore, (flightInfoStore: FlightInfoStore) => ({
    amenities: flightInfoStore.richContent.amenitiesMap,
    $fare: flightInfoStore.$fare,
    disclaimerList: flightInfoStore.disclaimers.disclaimerList,
    $resources: flightInfoStore.$resources,
    $currency: flightInfoStore.$env.currency,
  }));
};

export default useStateOfFlightDetails;
